import { render, staticRenderFns } from "./RecipeEdit.vue?vue&type=template&id=9fbd74e8&scoped=true"
import script from "./RecipeEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeEdit.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RecipeEdit.vue?vue&type=style&index=0&id=9fbd74e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbd74e8",
  null
  
)

export default component.exports